import {useState} from 'react'

import {Breakpoint, Button, Dialog, LazyImage, useBreakpoint} from '@sdox/ui'
import {IconInstagram} from '@sdox/icons'
import {getTrackingProps} from '@sdox/utils/dom'

import {Dialogs} from '../Dialogs'

import type {XcNwBlock_BlockInstagramType_Fragment} from '@sdox/api'

export const BlockInstagram = (props: XcNwBlock_BlockInstagramType_Fragment) => {
  const {name, logo, href, instaItems} = props
  const [dialogPostIndex, setDialogPostIndex] = useState<number>()
  const mdAndUp = useBreakpoint(Breakpoint.MD_AND_UP)

  const onCloseDialog = (): void => {
    setDialogPostIndex(undefined)
  }

  return (
    <div data-cy={'block-instagram'}>
      <div className={'flex items-center justify-between gap-3 md:gap-0'}>
        <div className={'flex items-center gap-3'}>
          <span className={'size-spacing-44 rounded-full p-spacing-2'}>
            <LazyImage
              className={'size-full object-contain object-center'}
              src={logo?.thumbnailUrl}
              alt={'instagram profil'}
              hasBackground={false}
            />
          </span>
          <span>{name}</span>
        </div>
        <Button
          variant={'outline'}
          size={mdAndUp ? 'medium' : 'small'}
          onClick={() => window.open(href, '_blank')}
          mboAttrs={{prefix: 'BlockInstagram', piece: 'FollowOnInstagram'}}
        >
          <div className={'flex items-center gap-2'}>
            <IconInstagram className={'size-8'}/>
            <span className={'hidden lg:inline'}>
              Auf Instagram folgen
            </span>
            <span className={'lg:hidden'}>Folgen</span>
          </div>
        </Button>
      </div>
      <div className={'mt-4 grid grid-cols-3 gap-1 md:mt-12 md:gap-3'}>
        {instaItems.slice(0, 6).map((post, postIndex) => (
          <button
            key={post.image.id}
            onClick={() => setDialogPostIndex(postIndex)}
            {...getTrackingProps({prefix: 'BlockInstagramItems', piece: `Item${postIndex + 1}`})}
          >
            <LazyImage
              className={'aspect-1 size-full cursor-pointer object-cover'}
              src={post.image.thumbnailUrl}
              alt={'instagram post'}
            />
          </button>
        ))}
      </div>
      <Dialog
        open={dialogPostIndex !== undefined}
        onClose={onCloseDialog}
        size={'medium'}
      >
        {dialogPostIndex !== undefined && (
          <Dialogs.InstagramFeed
            instaBlock={props}
            postIndex={dialogPostIndex}
            onClose={onCloseDialog}
          />
        )}
      </Dialog>
    </div>
  )
}
